import { height, width } from "@mui/system";
import { imageIconHoverSx, fsImageIconHoverSx, transparentIconButtonSx } from "@/styles/iconHover";

// Icon hover aesthetics live in @/styles/iconHover - these are kept as ready-to-use
// defaults for the existing call sites.
export const iconImgSx = imageIconHoverSx();

export const fsIconImgSx = fsImageIconHoverSx();

export const iconButtonSx = transparentIconButtonSx();

export const iconButtonBig = transparentIconButtonSx({ size: '12vh' });

export const glassPanelSx = {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    borderRadius: 4,
    padding: 4,
    ml:5,
    color: 'white',
    minWidth: '400px',
    pointerEvents: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 1
};

export const PANEL_BUTTON_WIDTH = '135px'
export const PANEL_BUTTON_HEIGHT = '35.5px'
export const SOCIAL_ACCOUNT_BUTTON_WIDTH = '150px'

export const OP_BUTTON_STYLE = {
    width: PANEL_BUTTON_WIDTH,
    height: PANEL_BUTTON_HEIGHT,
}

export const RIGHT_DRAWER_WIDTH = '400px'
export const CHAT_FONT = '12px'

export const DASHED_SEPARATOR_STYLE = "2px dotted rgba(80, 80, 80, 0.8)"
